import { useState, useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

function useOrder() {
  const { api, userID } = useContext(GlobalContext);

  const [deliveryType, setDeliveryType] = useState("");
  const [loading, setLoading] = useState(false);

  /* GET DELIVERY PARTNER */

  const getDeliveryType = async () => {
    try {
      setLoading(true);

      const requestBody = {
        userid: userID,
        secret: "string",
      };

      const response = await api.post(
        "/Order/getDeliveryProvider",
        requestBody
      );

      if (response.data.responseCode === "00") {
        setDeliveryType(response.data.response.deliveryPartner);
      }

      return response.data;
    } catch (error) {
      console.error("Get Delivery Type Error:", error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  /* UPDATE DELIVERY PARTNER */

  const selectDeliveryPartner = async (partnerType) => {
    try {
      setLoading(true);

      const requestBody = {
        userid: userID,
        deliveryPartner: partnerType,
        secret: "string",
      };

      const response = await api.post(
        "/Order/updateDeliveryProvider",
        requestBody
      );

      if (response.data.responseCode === "00") {
        setDeliveryType(partnerType);
      }

      return response.data;
    } catch (error) {
      console.error("Update Delivery Partner Error:", error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    deliveryType,
    loading,
    getDeliveryType,
    selectDeliveryPartner,
  };
}

export default useOrder;